export default __webpack_public_path__ + "static/media/dropdown-toolbar-variations-2.97ac25d6.png";